import React, { useEffect } from "react";
import {
    Breadcrumb
} from "react-bootstrap";
import TableTinDang
    from "../../components/Tables/DataTable/My_Tables/table_tindang";

const TinDang = ({ setIsAuthPage }) => {
    useEffect(() => {
        // Example: Set isAuthPage to false when TinDang mounts
        if (setIsAuthPage) {
            setIsAuthPage(false);
        }
    }, [setIsAuthPage]);

    return (
        <>
            <div
                className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
                <h3 className="mb-0">Data
                    Tables</h3>

                <Breadcrumb
                    className="breadcrumb-page-list align-items-center mb-0 lh-1">
                    <Breadcrumb.Item
                        href="/dashboard/ecommerce">
                        <div
                            className="d-flex align-items-center text-decoration-none">
                            <i className="ri-home-4-line fs-18 text-primary me-1"></i>
                            <span
                                className="text-secondary fw-medium hover">Dashboard</span>
                        </div>
                    </Breadcrumb.Item>

                    <Breadcrumb.Item>
                        <span
                            className="fw-medium">Tables</span>
                    </Breadcrumb.Item>

                    <Breadcrumb.Item
                        active>
                        <span
                            className="fw-medium">Data Tables</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>


            <TableTinDang/>


        </>
    );
};

export default TinDang;
